import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/admissions/admission-applications.$id";

export const Route = createFileRoute(
  "/admin/_admissions/admission-applications/$id"
)({
  component: Page,
});
